import { defineStore } from 'pinia'
import { ref, watchEffect } from 'vue'
import { useLoadCabinetAdminConfiguratorTemplates } from './../model/api'
import { useTranslate } from '@/shared/lib'

const useModelTable = defineStore('cabinet_admin_config_templates_table', () => {
  const { trs } = useTranslate()

  const open = ref(false)
  const templates = ref<any[]>([])
  const events = ref<any[]>([])

  /**
   * Настройки шапки формы
   */
  const headers = ref<any>([
    { title: trs('itf.name'), key: 'name' },
    { title: trs('itf.control'), key: 'action', sortable: false, align: 'end' },
  ])

  const loadTable = () => {
    const result = useLoadCabinetAdminConfiguratorTemplates()

    watchEffect(() => {
      if (result.data.value) {
        templates.value = result.data.value.data
        events.value = result.data.value.payload.events
      }
    })

    return result
  }

  return {
    open,
    templates,
    headers,
    events,

    loadTable,
  }
})

export { useModelTable }
